import React from 'react';
import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import logo_dark from '../../assets/svgs/a1_logo_dark.svg';
import logo_light from '../../assets/svgs/a1_logo_light.png';

interface LogoProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({ width = 27, text = true, textClass, className }: LogoProps) => {
  const {
    config: { isDark }
  } = useAppContext();
  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img src={isDark ? logo_dark : logo_light} alt="phoenix" width={width} />
      {text && (
        <p className={classNames(textClass, 'logo-text ms-2')}>phoenix</p>
      )}
    </div>
  );
};

export default Logo;
